export default function Component(t, p) {

    var CustomLoader = function(resolution, path, secondsToLoad, name, debug) {
        this.path = path;
        this.secondsToLoad = secondsToLoad;
        this.subscription = null;
        this.resolution = resolution / 1000;
        this.name = decodeURIComponent(name);
        this.debug = debug === "true";
    };

    CustomLoader.prototype.destroy = function() {
        if (this.subscription) {
            p.unsubscribeDS(this.updateDsCallback, this.subscription);
        }
    };

    CustomLoader.prototype.mapOptions = function(options) {

    };

    CustomLoader.prototype.load = function(cb, pushCb, context) {
        const loaderSelf = this;

        p.getHistorySeconds(this.path, this.secondsToLoad, loaderSelf.resolution).then(function (history) {
            if (history.data.length === 0) {
                return [];
            }

            /* Get any historic data and store them in an array of number arrays. 
             * Each entry must contain 6 values in this particular order:
             * Timestamp in milliseconds, close, open, high, low, volume
             */

            var lastOHLC = undefined;
            var lastTimeSlice = history.lastTimeSlice;
            if (history.data.length) {
                const lastItem = history.data[history.data.length - 1];
                lastOHLC = {
                    'open': +lastItem[2],
                    'close': +lastItem[1],
                    'low': +lastItem[4],
                    'high': +lastItem[3],
                    'time': +lastTimeSlice,
                    'quote': +lastItem[1],
                    'volume': +lastItem[5]
                };
            }
            
        
            /* To support conversions between resolutions, a timezone, start and 
             * end time (in milliseconds since beginning of a day) must be provided. 
             */

            var metadata = {
                timezone: 'Europe/Berlin',
                startTime: 0, // 00:00
                endTime: 0, // 23:59:59
                hasVolume: true,
                precision: 3,
                name: loaderSelf.name
            };

            /* An Error can be given as first argument.  
             */

            // console.log("chart size", history.data.length, loaderSelf.path);
            if (history.data.length >= 2) {
                // console.log("chart duration in seconds", (history.data[history.data.length - 1][0] - history.data[0][0]));
            }

            cb(null, metadata, history.data);

            const cloneOHLC = function (newestTimeSlice) {
                while (lastTimeSlice + 1 < newestTimeSlice) {
                    const lastOHLCCopy = {
                        'open': lastOHLC.open,
                        'close': lastOHLC.close,
                        'low': lastOHLC.low,
                        'high': lastOHLC.high,
                        'time': (++lastTimeSlice) * loaderSelf.resolution * 1000,
                        'volume': 1 /*,
                        'quote': lastOHLC.quote */
                    };
                    // if (loaderSelf.debug) { console.log("detailChartFn i", lastOHLCCopy); }
                    pushCb(lastOHLCCopy);
                }
                lastTimeSlice = newestTimeSlice - 1;
            };

            loaderSelf.updateDsCallback = function(value) {
                // if (loaderSelf.debug) { console.log("detailChartFnUp", value); }
                if (value.h && value.v && value.v.length) {
                    if (loaderSelf.resolution != 10) {
                        pushCb({'time': value.ts, 'quote': value.v, 'volume': 0});
                        return;
                    }
                    for (var i in value.h) {
                        const h = value.h[i];

                        lastOHLC = {
                            'open': +h.a,
                            'close': +h.a,
                            'low': +h.l,
                            'high': +h.h,
                            'time': +h.ts * 10 * 1000,
                            volume: 0 /*,
                            'quote': value.v */
                        };

                        // Add any missing AHL slices if there are holes in the sequence
                        cloneOHLC(h.ts);

                        // if (loaderSelf.debug) { console.log("detailChartFn h", h, lastOHLC); }
                        pushCb(lastOHLC);
                        lastTimeSlice++;
                    }
                    return;
                }
                var latestTS;
                if (value.tsLast) {
                    latestTS = value.tsLast;
                } else {
                    latestTS = value.ts;
                }
                // if (loaderSelf.debug) { console.log("detailChartFnUp ts", latestTS); }
                if (latestTS) {
                    const thisTimeSlice = Math.ceil(latestTS / loaderSelf.resolution/ 1000);
                    if (thisTimeSlice > lastTimeSlice && lastOHLC) {
                        // Add any missing AHL slices if there are holes in the sequence
                        cloneOHLC(thisTimeSlice);
                    } else {
                        if (loaderSelf.debug) { console.log("detailChartFn ts not new", latestTS, thisTimeSlice, lastTimeSlice); }
                    }
                    if (value.v) {
                        lastOHLC.quote = value.v;
                    }
                }
            };

            loaderSelf.subscription = p.subscribeDS(loaderSelf.path, loaderSelf.updateDsCallback, false);
        }).catch((e) => {
            console.debug('Cannot read data', e);
        });
    };

    BG.charts.setClazz({
        'clazzType': 'loader',
        'type': 'OmSense',
        'resolutions': [
            10*1000,
            10 * 60 * 1000,
            BG.charts.ESpans.HOUR,
            BG.charts.ESpans.DAY
        ],
        'flags': BG.charts.Object.EFlags.NONE,
        'clazz': CustomLoader
    });

    return CustomLoader;
}
